import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import NonameConfigListing from './NonameConfigListing'
import NonameCredentialsForm from './NonameCredentialsForm'

export default function NonamePullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={NonameCredentialsForm}
            PullConfigListingView={NonameConfigListing}
            RunOnDemandButtonText={'Sync tool applications'}
        />
    )
}
